import(/* webpackMode: "eager", webpackExports: ["TeamCompPage"] */ "/home/runner/work/Planner/Planner/src/components/team/TeamCompPage.tsx");
